(() => {
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-reference-variant]');
    if (!select || !select.value) return;
    const card = select.closest('.pcard'), choice = select.selectedOptions[0];
    card.querySelector('.pcard__price').textContent = choice.dataset.price;
    let was = card.querySelector('.pcard__was');
    if (!was) { was = document.createElement('span'); was.className = 'pcard__was'; card.querySelector('.pcard__pricing').prepend(was); }
    was.textContent = choice.dataset.was;
    was.hidden = !choice.dataset.was;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-open-finder]');
    if (!link) return;
    const finder = document.querySelector('#urun-bulucu'), disclosure = finder?.querySelector('details');
    if (!finder) return;
    if (disclosure) disclosure.open = true;
    const liters = finder.querySelector('[name="liters"]');
    if (liters) liters.value = link.dataset.liters || '';
    finder.querySelector('[data-finder-tab="' + link.dataset.openFinder + '"]')?.click();
  });
})();
